import { Component } from 'react';
import CategoriesHorizontalBarChart from 'legacy/javascripts/components/categories_horizontal_bar_chart.es6.jsx';

class FollowUpCategories extends Component {
  render() {
    return (
      <CategoriesHorizontalBarChart
        id="followUpCategories"
        type="horizontalBar"
        columns={this.props.data.columns}
        datasets={this.props.data.datasets}
        docCount={this.props.data.doc_count}
        chartMax={this.props.data.chart_max}
      />
    );
  }
}

export default FollowUpCategories;
